var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 9.33118V6.82651C7.07812 4.98211 8.3864 3.48694 10.0002 3.48694C11.6141 3.48694 12.9224 4.98211 12.9224 6.82651V9.33118",
    stroke: "#C1C7D4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74023 9.33118H15.2599V15.5131C15.2599 16.6177 14.3644 17.5131 13.2599 17.5131H6.74023C5.63566 17.5131 4.74023 16.6177 4.74023 15.5131V9.33118Z",
    stroke: "#C1C7D4",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13.3359,
    r: 1.25,
    fill: "#C1C7D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSecurity);
export default __webpack_public_path__ + "static/media/profile-security.cda9638989cf63e83169abe4ae2bf080.svg";
export { ForwardRef as ReactComponent };